"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = activeElement;
var _ownerDocument = _interopRequireDefault(require("./ownerDocument"));
function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }
  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}
module.exports = exports["default"];